/**
 * Utility functions for offer templates
 */

/**
 * Calculates the validity date for an offer (7 days from creation/publication)
 * @param offer - Offer object with publishedAt and createdAt dates
 * @param utils - Template utils object with formatDate function
 * @returns Formatted validity date string
 */
export const getFormattedOfferValidityDate = (
  offer: {
    publishedAt?: string;
    createdAt: string;
  },
  utils: { formatDate: (dateString: string) => string }
): string => {
  const baseDate = offer.publishedAt || offer.createdAt;
  const validityDate = new Date(
    new Date(baseDate).getTime() + 7 * 24 * 60 * 60 * 1000 // 7 days in milliseconds
  );
  return utils.formatDate(validityDate.toISOString());
};
